import { VacanciesService } from './../../vacancies.service';
import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { EmailListWithExternalAccessModalComponent } from '../email-list-with-external-access-modal/email-list-with-external-access-modal.component';
import { Router } from '@angular/router';

@Component({
	selector: 'app-list-step-module-filter-modal',
	templateUrl: './list-step-module-filter-modal.component.html',
	styleUrls: ['./list-step-module-filter-modal.component.scss']
})
export class ListStepModuleFilterModalComponent implements OnInit {
	@Input() rootType: string = 'vacancies' as string;
	@Input() title: string = 'Link de feedback' as string;
	@Input() vacancyId: string = '';
	@Input() stepId: string = '';

	public modalResult: any;
	public loadingFilter: boolean = true;
	public screeningFilter: any;

	constructor(
		private vacanciesService: VacanciesService,
		private modalService: NgbModal,
		private router: Router,
		private vacancyService: VacanciesService,
	) { }

	ngOnInit() {
		this.vacancyService.getVacancyStepModuleFilter(this.vacancyId, this.stepId)
			.subscribe(filter => {
				this.loadingFilter = true;
				this.screeningFilter = filter;
			});
	}

	public allowExternalGuestAccess(): void {
		const modal = this.modalService.open(EmailListWithExternalAccessModalComponent, { size: 'lg', backdrop: false });
		modal.componentInstance.emailsFromTheExternalLinks = this.screeningFilter.emailsFromTheExternalLinks || [];
		modal.componentInstance.htmlDescription = `Informe os emails das pessoas que devem receber o Link`

		modal.result.then(result => {
			if (result) {
				this.screeningFilter.emailsFromTheExternalLinks = result;
	
				this.vacanciesService.patchScreeningFilterExternalAccess(this.vacancyId, this.screeningFilter._id, {
					emailsFromTheExternalLinks: result
				}).subscribe(response => { })
			}
		}).catch(err => { });
	}

	public openFeedbackLink(): void {
		if (!this.screeningFilter || !this.screeningFilter.filters.step) {
		  return;
		}

		let link = this.router.createUrlTree([`/public/${this.rootType}/${this.vacancyId}/steps/${this.screeningFilter.filters.step}/tests/${this.screeningFilter.filters.test}/feedback-test`]);

		switch (this.screeningFilter.module) {
            case 'test':
                link = this.router.createUrlTree([`/public/${this.rootType}/${this.vacancyId}/steps/${this.screeningFilter.filters.step}/tests/${this.screeningFilter.filters.test}/feedback-test`]);
            break;
            default:
                link = this.router.createUrlTree([`/public/${this.rootType}/${this.vacancyId}/steps/${this.screeningFilter.filters.step}/tests/${this.screeningFilter.filters.test}/feedback-test`]);;
            break;
        }

		const url = this.router.serializeUrl(link);

		window.open(url, '_blank');
	}
}
